(function initializeSubmitButton(){
    var submitButtons = $( '._submit-button' );

    submitButtons.on( 'click', function( event ){
        var _this = $( this );
        var form = _this.parents( 'form:first' );

        event.preventDefault();

        if( form.data( 'validator' ) ){
            if( form.valid() ){
                _this.data( 'button-content', _this.html() );
                _this.html( '<i class="fa fa-cog fa-spin"></i>' );
                form.trigger('submit');
                _this.attr( 'disabled', true );
            }
        }
        else{
            _this.html( '<i class="fa fa-cog fa-spin"></i>' );
            form.trigger('submit');
            _this.attr( 'disabled', true );
        }
    } );

    submitButtons.removeAttr( 'disabled' );
})();
